import { Badge } from 'antd'
import type { FeedbackStatus } from '@/types/feedback.types'

/**
 * Props for FeedbackStatusBadge
 */
export interface FeedbackStatusBadgeProps {
  status: FeedbackStatus
}

/**
 * FeedbackStatusBadge Component
 *
 * Displays feedback status with color-coded badge.
 *
 * Color mapping:
 * - New: Blue (#1890ff)
 * - In Progress: Orange (#fa8c16)
 * - Resolved: Green (#52c41a)
 * - Won't Fix: Gray (#d9d9d9)
 * - Duplicate: Purple (#722ed1)
 */
export const FeedbackStatusBadge: React.FC<FeedbackStatusBadgeProps> = ({ status }) => {
  const getStatusColor = (status: FeedbackStatus): string => {
    switch (status) {
      case 'New':
        return 'blue'
      case 'In Progress':
        return 'orange'
      case 'Resolved':
        return 'green'
      case "Won't Fix":
        return 'default'
      case 'Duplicate':
        return 'purple'
      default:
        return 'default'
    }
  }

  return <Badge status={getStatusColor(status) as any} text={status} />
}

export default FeedbackStatusBadge
